import { DateTime } from 'luxon'

export const API_URL = process.env.REACT_APP_API_URL

export const AWS_USER_POOL_ID = process.env.REACT_APP_AWS_USER_POOL_ID
export const AWS_USER_POOL_APP_CLIENT_ID = process.env.REACT_APP_AWS_USER_POOL_APP_CLIENT_ID

export const APP_VERSION = DateTime.fromMillis(Number(process.env.REACT_APP_BUILD_DATE)).toFormat('yyyy.MM.dd.HH.mm')
